import { Box, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const PatientToolbar = (props) => {
  const { handleClick, label } = props;
  return (
    <Box {...props}>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          mb:1,
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <IconButton
            aria-label="back"
            onClick={() => handleClick("back")}
          >
            <ArrowBackIcon color="primary" />
          </IconButton>
          <Typography
            sx={{ m: 1, fontSize: "1.45rem", color: "primary.dark" }}
            variant="h4"
          >
            {label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
